
import React from "react"
import Accusation from "./accusation-screen"
import { AccusationScreenNavigationProps } from "./types"
import { PageRoot } from "~screens/page-root"


const AccusationScreen: React.FC<AccusationScreenNavigationProps> = ({ route }) => {
  return (
    <PageRoot>
      <Accusation userId={route.params.userId} />
    </PageRoot>
  )
}

export default AccusationScreen
